import { useEffect, useMemo, useState } from "react";
import { ChevronRight, Search } from "lucide-react";
import { Modal } from "../components/common";
import { api, errMsg } from "../lib/api";

export const AddMTAccountModal = ({ onClose, onSaved, metaapiReady }) => {
  const [form, setForm] = useState({ platform: "MT5", broker: "", server: "", login: "", investor_password: "" });
  const [query, setQuery] = useState("");
  const [brokers, setBrokers] = useState([]);
  const [live, setLive] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  useEffect(() => {
    const t = setTimeout(() => {
      api.get("/brokers/servers", { params: { platform: form.platform, q: query } }).then((r) => { setBrokers(r.data.brokers); setLive(r.data.live_search); });
    }, 300);
    return () => clearTimeout(t);
  }, [form.platform, query]);

  const servers = useMemo(() => brokers.find((b) => b.name === form.broker)?.servers || [], [brokers, form.broker]);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/trading/accounts/mt", form);
      onSaved();
    } catch (err) {
      setError(errMsg(err, "Akun belum tersimpan. Periksa data lalu coba lagi."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal onClose={onClose} testId="mt-account-modal">
      <form onSubmit={save}>
        <p className="eyebrow">MT4 / MT5 · READ-ONLY</p>
        <h3>Hubungkan akun MetaTrader</h3>
        <p className="muted">Gunakan <b>password investor</b> agar akses hanya membaca histori, tanpa bisa membuka posisi.</p>
        <div className="seg">
          {["MT5", "MT4"].map((p) => (
            <button type="button" key={p} className={form.platform === p ? "active" : ""} onClick={() => setForm({ ...form, platform: p, server: "" })} data-testid={`mt-platform-${p}`}>{p}</button>
          ))}
        </div>
        <label>Cari broker
          <span className="input-icon"><Search size={15} /><input value={query} placeholder="Exness, XM, IC Markets…" onChange={(e) => setQuery(e.target.value)} data-testid="broker-search-input" /></span>
        </label>
        <label>Broker
          <select required value={form.broker} onChange={(e) => setForm({ ...form, broker: e.target.value, server: "" })} data-testid="broker-select">
            <option value="">Pilih broker</option>
            {brokers.map((b) => <option key={b.name} value={b.name}>{b.name}</option>)}
          </select>
        </label>
        <label>Server
          <input required list="server-options" value={form.server} placeholder={servers[0] || "Nama server di terminal MT"} onChange={set("server")} data-testid="server-input" />
          <datalist id="server-options">{servers.map((s) => <option key={s} value={s} />)}</datalist>
        </label>
        {servers.length > 0 && (
          <div className="chips" data-testid="server-suggestions">
            {servers.map((s) => <button type="button" key={s} className={form.server === s ? "chip active" : "chip"} onClick={() => setForm({ ...form, server: s })}>{s}</button>)}
          </div>
        )}
        <small className="muted">{live ? "Daftar server diperkaya pencarian langsung MetaApi." : "Server tidak ada di daftar? Ketik manual sesuai yang tertera di terminal MT Anda."}</small>
        <label>Login (nomor akun)<input required inputMode="numeric" value={form.login} onChange={set("login")} data-testid="mt-login-input" /></label>
        <label>Password investor<input required type="password" value={form.investor_password} onChange={set("investor_password")} data-testid="mt-investor-password-input" /></label>
        {!metaapiReady && <div className="warn-box" data-testid="metaapi-pending-note">Konektor MetaApi belum diaktifkan admin. Akun akan disimpan terenkripsi dan otomatis tersambung setelah aktif.</div>}
        {error && <div className="error" data-testid="mt-account-error">{error}</div>}
        <button className="primary full" disabled={busy} data-testid="save-mt-account-button">{busy ? "Menyimpan…" : "Hubungkan & sinkronkan"} <ChevronRight size={17} /></button>
      </form>
    </Modal>
  );
};
